export default "__VITE_ASSET__Dn65W2w8__"